import { render, staticRenderFns } from "./Changepassword.vue?vue&type=template&id=751c4d27&scoped=true&lang=html"
import script from "./Changepassword.vue?vue&type=script&lang=js"
export * from "./Changepassword.vue?vue&type=script&lang=js"
import style0 from "./Changepassword.vue?vue&type=style&index=0&id=751c4d27&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751c4d27",
  null
  
)

export default component.exports